import { render, staticRenderFns } from "./cubeOverflow.vue?vue&type=template&id=6d0022ac&scoped=true&"
import script from "./cubeOverflow.vue?vue&type=script&lang=js&"
export * from "./cubeOverflow.vue?vue&type=script&lang=js&"
import style0 from "./cubeOverflow.vue?vue&type=style&index=0&id=6d0022ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0022ac",
  null
  
)

export default component.exports